import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import SoftwareSolutions from "../pages/Software";
import AiSolutions from "../pages/AiSolutions";
import Audits from "../pages/Audits";
import Training from "../pages/Training";
import Blockchain from "../pages/Blockchain";
import SecurityWa from "../pages/Security";
import ScrollToTop from "../components/ScrollToTop";
import TermsWa from "../pages/Terms";
import Privacy from "../pages/Privacy";
import Error404 from "../pages/Error404";

export const Navigation = () => {
  
  return (
    <ScrollToTop>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/software-solutions" element={<SoftwareSolutions /> } />
            <Route path="/ai-solutions" element={<AiSolutions /> } />
            <Route path="/blockchain" element={<Blockchain /> } />
            <Route path="/audits-and-consulting" element={<Audits /> } />
            <Route path="/training" element={<Training />} />
            <Route path="/security" element={<SecurityWa /> } />
            <Route path="/terms" element={<TermsWa />} />
            <Route path="/privacy-policy" element={<Privacy /> } />

            <Route path="*" element={<Error404 />} />

      </Routes>
    </ ScrollToTop>
  );
}

